function updatePositions() {
  const screenWidthThreshold = 52 * 16 - 1;
  const extraOffset = 50;

  if (window.innerWidth > screenWidthThreshold) {
    const scrollY = window.scrollY;

    document
      .querySelectorAll(
        '.text-hero, .hero__text-1--img, .hero__subtext, .hero__shape--message, .hero__text-1__shape, .hero__subtext--shape'
      )
      .forEach((element) => {
        const rect = element.getBoundingClientRect();
        // Check if the element is within the viewport plus the extra offset
        if (rect.bottom >= -extraOffset && rect.top <= window.innerHeight + extraOffset) {
          let offset;
          switch (element.className) {
            case 'text-hero':
              offset = scrollY * -1.7;
              break;
            case 'hero__text-1--img':
              offset = scrollY * -0.2;
              break;
            case 'hero__subtext':
              offset = scrollY * -1.9;
              break;
            case 'hero__shape--message':
              offset = scrollY * -2.6;
              break;
            case 'hero__text-1__shape':
              offset = scrollY * -2.2;
              break;
            case 'hero__subtext--shape':
              offset = scrollY * -0.2;
              break;
          }
          element.style.translate = `0 ${offset}px`;
        }
      });
  }
}

document.addEventListener('scroll', function () {
  requestAnimationFrame(updatePositions);
});
